








import {Component, Vue} from 'vue-property-decorator';

@Component({})

export default class traineeLayout extends Vue {
    async mounted() {

    }

}

